import { gql } from '@apollo/client';

export const queryCities = gql`
  query CMS_StrategyCities {
    getActiveCities(pageSize: 9999, sortBy: NAME, sortDirection: ASCENDING) {
      totalCount
      edges {
        node {
          slug
          id
          name
          originalName
        }
      }
    }
  }
`;

export const queryHomepageSetting = gql`
  query CMS_QueryHomepageSetting($citySlug: String) {
    getHomepageSetting(citySlug: $citySlug) {
      homepageSetting {
        city {
          name
        }
        desktopSetting
      }
    }
  }
`;

export const updateHomepageSetting = gql`
  mutation CMS_UpdateHomepageSetting($input: UpdateHomepageSettingInput!) {
    updateHomepageSetting(input: $input) {
      homepageSetting {
        city {
          name
        }
        desktopSetting
      }
    }
  }
`;

export const queryHeroBanner = gql`
  mutation CMS_QueryListBanners($cityId: String, $locale: BannerLocale!) {
    listBanners(cityId: $cityId, locale: $locale) {
      banner {
        allCountries
        id
        link
        effectiveStartDate
        effectiveEndDate
        imageHash
        contentType
        updatedAt
        extension
        filename
        createdUser {
          firstName
          lastName
        }
        updatedUser {
          firstName
          lastName
        }
        country {
          name
          id
        }
        cities {
          name
          id
        }
      }
    }
  }
`;

export const queryBannerDetail = gql`
  query CMS_QueryBannerDetail($id: String) {
    getBanner(id: $id) {
      banner {
        allCountries
        id
        link
        effectiveStartDate
        effectiveEndDate
        imageHash
        contentType
        updatedAt
        extension
        filename
        createdUser {
          firstName
          lastName
        }
        updatedUser {
          firstName
          lastName
        }
        country {
          name
          id
        }
        cities {
          name
          id
        }
      }
    }
  }
`;

export const deletedHeroBanner = gql`
  mutation CMS_DeleteHeroBanner($input: DeleteBannerInput) {
    deleteBanner(input: $input) {
      success
    }
  }
`;

export const createHeroBanner = gql`
  mutation CMS_CreateBanner($input: CreateBannerInput!) {
    createBanner(input: $input) {
      banner {
        id
      }
    }
  }
`;

export const updateHeroBanner = gql`
  mutation CMS_UpdateBanner($input: UpdateBannerInput!) {
    updateBanner(input: $input) {
      banner {
        id
      }
    }
  }
`;

export const updateBannerPositions = gql`
  mutation CMS_UpdateBannerPositions($input: UpdatePositionInput) {
    updateBannerPositions(input: $input) {
      success
    }
  }
`;

export const queryCity = gql`
  query CMS_CityView($slug: String) {
    city(slug: $slug) {
      id
      name
      slug
      country {
        id
        name
        slug
      }
    }
  }
`;

export const getActiveCities = gql`
  query CMS_GetActiveCities($countrySlugs: [String], $pageSize: Int = 9999) {
    getActiveCities(countrySlugs: $countrySlugs, pageSize: $pageSize) {
      edges {
        node {
          id
          name
          slug
        }
      }
    }
  }
`;
